/**
 * Every query that shows AI settings. Any change to the draft or a version can
 * move what each of them returns — creating a version ends the draft, going
 * live moves the badge — so they are read again together.
 */
export const aiSettingsQueryNames = ['AiSettingsVersion', 'AiSettingsVersions'];

/** The draft, or what stands in for it while there is none. */
export const draftVariables = {};
